// status in CC
export const ACTIVE = "Active";
export const COMPLETE = "Complete";
export const INPROGRESS = "InProgress";
export const NOT_APPLICABLE = "NotApplicable";

export const CARE_MANAGEMENT_TASK_STATUS_DROPDOWN_MAPPING = [
  {
    value: ACTIVE,
    label: "To Do"
  },
  {
    value: COMPLETE,
    label: "Done"
  },
  {
    value: INPROGRESS,
    label: "In Progress"
  },
  {
    value: NOT_APPLICABLE,
    label: "N/A"
  },
]

// types of subtask in CC
export const Info = "INFO";
export const ActionNoValue = "ACTN-NOVALUE";
export const ActionRadio = "ACTN-RADIO";
export const ActionFreeText = "ACTN-FREETXT";
export const SingleDropDown = "ACTN-1DRPDWN";
export const DoubleDropDown = "ACTN-2DRPDWN";
export const TripleDropDown = "ACTN-3DRPDWN";
export const SingleDate = "ACTN-1DATE";
export const ActionMultiDropDown = "ACTN-MSELDRPDWN";
export const ActionButton = "ACTN-BUTTON";
export const ActionRemainder = "ACTN-REMINDER";
export const ActionRadioPrgm = 'ACTN-RADIOPRGM';
export const ActionDateTime = 'ACTN-DATETIME';
export const ActionMultiLevel = "ACTN-MULTIDRPDWN";
export const ActionTextArea = 'ACTN-FREETXTLEN';

// directions in CC
export const PREVIOUS = "previous";
export const NEXT = "next";

export const tasksActions = [
  {
    action: "delete",
    isDisabled: false,
    isVisible: true,
  },
  {
    action: "barrier",
    isDisabled: false,
    isVisible: true,
  },
];

export interface Note {
  isBookmarked: boolean;
  notes: string;
  notesCreateDate: string;
  notesId: string;
}

export const SYSTEM = 'System';

export const CHECKBOX = "checkbox";
export const RADIO = "radio";
export const OTHER = "Other";